import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsUUID, IsEnum, IsArray } from 'class-validator'
import { Type, Transform } from 'class-transformer'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'
import { PedagogicContentState } from '../../../enums/content.enum'

/**
 * DTO pour filtrer les enseignements avec pagination offset
 */
export class ListTeachingsQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    description: 'Filtrer par ID de matière',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  subjectExternalId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par ID de niveau',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  levelExternalId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par ID de classe',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  classId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par ID de groupe',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  groupId?: string

  @ApiPropertyOptional({
    description: "Filtrer par ID d'année scolaire",
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  schoolYearId?: string

  @ApiPropertyOptional({
    description: "Filtrer par ID d'établissement",
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  establishmentId?: string

  @ApiPropertyOptional({
    description: 'États à inclure dans les résultats (DRAFT, ACTIVE, ARCHIVED)',
    enum: PedagogicContentState,
    isArray: true,
    example: ['ACTIVE', 'ARCHIVED'],
  })
  @IsOptional()
  @Transform(({ value }: { value: string | string[] }) => (Array.isArray(value) ? value : [value]))
  @IsArray()
  @IsEnum(PedagogicContentState, { each: true })
  @Type(() => String)
  includeStates?: PedagogicContentState[]

  @ApiPropertyOptional({
    description: 'Filtrer par ID de leçon',
    type: [String],
  })
  @IsOptional()
  @IsUUID('4')
  lessonIds?: string[]

  @ApiPropertyOptional({
    description: 'Filtrer par ID de chapitre (enseignements associés au chapitre)',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  chapterId?: string

  @ApiPropertyOptional({
    description:
      'Filtrer par IDs d\'enseignements (retourne uniquement ces enseignements)',
    isArray: true,
    type: [String],
  })
  @IsOptional()
  @Transform(({ value }: { value: string | string[] }) =>
    Array.isArray(value) ? value : value ? [value] : undefined
  )
  @IsArray()
  @IsUUID('4', { each: true })
  teachingIds?: string[]
}
